<template>
    <v-col class="register default-slot" md="7" sm="12">
      <div class="top-icons">
        <div class="top-icons">
          <a class="back-icon" v-on:click="changePage(2)">
            <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
          </a>
        </div>
      </div>      
      <v-alert width="100%" class="mr-5 ml-5" type="info">
        Pedigree can now be ordered online after the registration is approved by the ASCA office.<br/>
        The ID# of the dog will be listed in the litter details.<br/>
        To order pedigree go to the dog profile and click 'Order Pedigree' button.<br/>
      </v-alert>
      <h1 class="register-title">Summary & Payment Information</h1>
      <div class="mt-5 ml-10 d-flex justify-start flex-column align-start">
        <h3>
          <span><b>DOG REGISTRATION FEE: </b></span>
          <td>
              ${{ price }}
              <v-tooltip bottom content-class="fee-table-tooltip">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on"><font-awesome-icon icon="info-circle" /></span>
                </template>
                <dog-registration-fee-table :priceInfo="priceInfo" />
              </v-tooltip>
            </td>
        </h3>
        <h1 class="mt-3">
          <span><b>TOTAL: </b></span>
          <span>${{price}}</span>
        </h1>
      </div>
      <hosted-registration-payment
        buttonText="SUBMIT"
        v-on:updatePaymentInfo="submit"
      />
      <p class="steps">STEP <b>3</b> OF <b>3</b></p>
      <footer-text />
    </v-col>
  </template>


  <script lang="ts">
  import Vue from "vue";
  import FooterText from "@/components/common/FooterText.vue";
  import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
  import DogRegistrationFeeTable from "@/components/Portal/DogRegistrationFeeTable.vue";
  export default Vue.extend({
    name: "SummaryPayment",
    components: { FooterText, HostedRegistrationPayment, DogRegistrationFeeTable },
    props: {
      changePage: Function,
      submit: Function,
      price: Number,
      priceInfo: Array,
    },
    data: function () {
      return {}
    },
  });
  </script>